import { ShieldAlert, ShieldX } from "lucide-react";
import { Link } from "react-router-dom";
import { ColBadge, Empty, cn } from "./ui";
import { fmtIDR } from "../lib/format";

const List = ({ rows, testId }: { rows: any[]; testId: string }) => (
  <div className="max-h-52 overflow-auto -mx-1 px-1">
    {rows.length === 0 ? <Empty text="Tidak ada." /> : (
      <table className="yt-table text-xs" data-testid={testId}>
        <tbody>
          {rows.map((r: any) => (
            <tr key={r.loan_id}>
              <td><Link to={`/pinjaman/${r.loan_id}`} className="font-semibold hover:text-primary">{r.student.name}</Link><p className="text-muted-foreground num">{r.student.internal_id} · {r.student.unit || "-"}</p></td>
              <td><ColBadge col={r.col} /></td>
              <td className="num text-right font-semibold">{fmtIDR(r.outstanding)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export function PovRisk({ data, testId = "pov-risk" }: { data: any; testId?: string }) {
  const panels = [
    { key: "risk", icon: ShieldAlert, title: "Risk", sub: `Nonaktif dengan sisa (${data.risk.inactive_count}) · Col 5 macet (${data.risk.col5_count}) · tetap dihitung dalam NPL`, tone: "border-orange-300 dark:border-orange-900", text: "text-orange-700 dark:text-orange-300", d: data.risk },
    { key: "write_off", icon: ShieldX, title: "Write Off", sub: "Siswa dihapusbukukan · dikeluarkan dari perhitungan NPL & tagihan massal", tone: "border-red-400 dark:border-red-900", text: "text-red-700 dark:text-red-300", d: data.write_off },
  ];
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid={testId}>
      {panels.map((p) => (
        <div key={p.key} data-testid={`${testId}-${p.key}`} className={cn("rounded-xl border-2 p-4 bg-card", p.tone)}>
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2"><p.icon className={cn("h-5 w-5", p.text)} /><p className="font-semibold">{p.title}</p></div>
            <div className="text-right">
              <p className={cn("text-2xl font-bold num", p.text)} data-testid={`${testId}-${p.key}-count`}>{p.d.count}</p>
              <p className="text-xs num text-muted-foreground" data-testid={`${testId}-${p.key}-outstanding`}>{fmtIDR(p.d.outstanding)}</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-1 mb-3">{p.sub}</p>
          <List rows={p.d.list} testId={`${testId}-${p.key}-list`} />
        </div>
      ))}
    </div>
  );
}
